package com.example.mystybag.sharedmodels.project.requestModels.merchant

import com.example.mystybag.sharedmodels.AllCommands.STRIPE_GET_ONBOARDING_LINK
import com.example.mystybag.sharedmodels.base.BaseRequestModel
import kotlinx.serialization.Serializable

/**
 * Requests a fresh Stripe hosted onboarding link (Account Link) for the merchant.
 * Account Links are single-use and expire within minutes, so the client must
 * request a new one right before opening the onboarding flow.
 */
@Serializable
data class GetStripeOnboardingLinkRequestModel(
    val merchantId: Long = 0L
) : BaseRequestModel(api = STRIPE_GET_ONBOARDING_LINK)
